document.addEventListener("DOMContentLoaded", function () {
  attachAddToCartListeners();
  attachDropdownListeners(); // Ensure dropdown listeners are attached initially

  // function openCartDrawerAndCheckVariant(currentVariantId) {
  //   const cartDrawer = document.querySelector(".drawer__inner");
  //   if (cartDrawer) {
  //     fetch("/cart.js")
  //       .then((response) => response.json())
  //       .then((cart) => {
  //         const variantIdsInCart = cart.items.map((item) => item.id);
  //         if (variantIdsInCart.includes(currentVariantId)) {
  //         } else {
  //           $("body").addClass("overflow-hidden");
  //           $(".drawer").addClass("animate active");
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching cart data:", error);
  //       });
  //   }
  // }
  // window.addEventListener("load", () => {
  //   const currentVariantId = document.querySelector("input[name='id']").value; // Get the current variant ID from the form
  //   fetch("/cart.js")
  //     .then((response) => response.json())
  //     .then((cart) => {
  //       if (cart.item_count > 0) {
  //         // Check if there are items in the cart
  //         openCartDrawerAndCheckVariant(currentVariantId); // Open the cart drawer and check variant
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching cart data:", error);
  //     });
  // });

  // // Attach the listener to the product page "Add to Cart" form
  document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
    form.addEventListener("submit", function (e) {
      e.preventDefault(); // Prevent the form from submitting the traditional way

      const formData = new FormData(form); // Collect form data

      // Perform the AJAX call to add the product to the cart
      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Product added to cart:", data);

          const customdrawer = document.querySelector(".custom-drawer");
          customdrawer.classList.add("active");
          customdrawer.classList.add("animate");
          updateCartDrawer();
          // checkCartAndManageProduct();
        })
        .catch((error) => {
          console.error("Error adding product to cart:", error);
        });
    });
  });

  // function attachAddToCartListeners() {
  //   const addToCartButtons = document.querySelectorAll(".upsell_addtocart_btn");

  //   addToCartButtons.forEach(function (button) {
  //     button.addEventListener("click", function () {
  //       const productDiv = button.closest(".product-cart");
  //       const variantId = productDiv.getAttribute("data-limitLine");
  //       if (variantId) {
  //         addToCart(variantId);
  //       } else {
  //         console.error("Variant ID is not set.");
  //       }
  //     });
  //   });
  // }

  function attachAddToCartListeners() {
  const addToCartButtons = document.querySelectorAll(".upsell_addtocart_btn");

  addToCartButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      const productDiv = button.closest(".product-cart");
      const variantSelect = productDiv.querySelector('.variant-dropdown');
      const variantId = variantSelect ? variantSelect.value : null;

      if (variantId) {
        addToCart(variantId);
      } else {
        console.error("Variant ID is not set or dropdown not found.");
      }
    });
  });
}


  function addToCart(variantId) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Call updateCartDrawer to refresh the cart
        updateCartDrawer();
        console.log("Cart Updated: ", data);
        const customDrawer = document.querySelector(".custom-drawer");
        customDrawer.classList.remove("is-empty");
      })
      .catch((error) => {
        console.error("Error adding product to cart:", error);
      });
  }

  function updateCartDrawer() {
    fetch(window.location.href)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newCartDrawer = doc.querySelector(".drawer__inner");
        const currentCartDrawer = document.querySelector(".drawer__inner");
        if (currentCartDrawer && newCartDrawer) {
          currentCartDrawer.innerHTML = newCartDrawer.innerHTML;

          // Detach old listeners before reattaching
          detachAddToCartListeners();
          detachDropdownListeners();

          attachAddToCartListeners();
          attachDropdownListeners(); // Reattach dropdown listeners after cart update
          // Check the cart and manage the free product after updating the cart drawer
          // checkCartAndManageProduct();

          const loader = document.querySelector("cart-drawer-items .loader");
          loader.classList.remove("hidden");
          setTimeout(function () {
            loader.classList.add("hidden");
          }, 1000);
        }
      })
      .catch((error) => {
        console.error("Error fetching the cart drawer:", error);
      });
  }
  function attachDropdownListeners() {
    const dropdowns = document.querySelectorAll(".variant-dropdown");
    console.log("Attaching listeners to dropdowns:", dropdowns.length); // Log number of dropdowns found

    // Loop through each dropdown
    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener("change", function () {
        const selectedValue = this.value;

        // Find the parent product container
        const productDiv = this.closest(".product-cart");
        if (productDiv) {
          // Set data-limitLine attribute with selected value
          productDiv.setAttribute("data-limitLine", selectedValue);
        }

        // Get selected option's image URL and price
        const selectedOption = dropdown.options[dropdown.selectedIndex];
        const newImgUrl = selectedOption.getAttribute("data-img");
        const newPrice = selectedOption.getAttribute("data-price");
        const newComparePrice = selectedOption.getAttribute("data-compareprice");

        // Find the closest product container again for updating image and price
        if (productDiv) {
          // Update product image
          const productImage = productDiv.querySelector(".product_img img");
          if (productImage && newImgUrl) {
            productImage.src = newImgUrl;
          }

          // Update product price if you need to (you can modify this part to update the price in the DOM)
          const productPrice = productDiv.querySelector(".update_price");
          if (productPrice && newPrice) {
            productPrice.textContent = newPrice;
          }
          const productComparePrice = productDiv.querySelector(".upsell_compare_price");
          if (productComparePrice && newComparePrice) {
            productComparePrice.textContent = newComparePrice;
          }
        }
      });
    });
  }

  const variantIdGift1 = 53579215634761; // Variant ID for the first gift (sleep mask)
  const variantIdGift2 = 51259249426761; // Variant ID for the second gift (pillow)

  // Session storage keys to track manual removals within the current browser session
  const STORAGE_KEY_GIFT1_REMOVED = "gift1_manually_removed";
  const STORAGE_KEY_GIFT2_REMOVED = "gift2_manually_removed";

  // Track previous cart state and script-driven removals
  let prevGift1InCart = null;
  let prevGift2InCart = null;
  let scriptRemovedGift1 = false;
  let scriptRemovedGift2 = false;

  // Guard to prevent overlapping cart checks
  let isCheckingCart = false;

  // Simple debounce to avoid firing too rapidly from DOM mutations
  let checkCartTimeoutId = null;

  function markGiftManuallyRemoved(giftNumber) {
    const key = giftNumber === 1 ? STORAGE_KEY_GIFT1_REMOVED : STORAGE_KEY_GIFT2_REMOVED;
    sessionStorage.setItem(key, "true");
  }

  function clearGiftManuallyRemoved(giftNumber) {
    const key = giftNumber === 1 ? STORAGE_KEY_GIFT1_REMOVED : STORAGE_KEY_GIFT2_REMOVED;
    sessionStorage.removeItem(key);
  }

  function isGiftManuallyRemoved(giftNumber) {
    const key = giftNumber === 1 ? STORAGE_KEY_GIFT1_REMOVED : STORAGE_KEY_GIFT2_REMOVED;
    return sessionStorage.getItem(key) === "true";
  }

  function scheduleCheckCartAndManageProduct() {
    if (checkCartTimeoutId) {
      clearTimeout(checkCartTimeoutId);
    }
    checkCartTimeoutId = setTimeout(() => {
      checkCartAndManageProduct();
    }, 300);
  }

 function checkCartAndManageProduct() {
  if (isCheckingCart) {
    console.log("[GIFT LOGIC] Cart check already in progress, skipping.");
    return;
  }

  isCheckingCart = true;
  console.log("[GIFT LOGIC] Starting cart check");

  fetch("/cart.js")
    .then((response) => response.json())
    .then((data) => {
      const cartTotal = data.total_price; // Total cart price in cents
      const thresholdGift1 = 15000; // €140 in cents
      const thresholdGift2 = 25000; // €250 in cents

      // Check current exact quantities in the cart
      const gift1Item = data.items.find((item) => item.variant_id === variantIdGift1);
      const gift2Item = data.items.find((item) => item.variant_id === variantIdGift2);
      
      const gift1Qty = gift1Item ? gift1Item.quantity : 0;
      const gift2Qty = gift2Item ? gift2Item.quantity : 0;

      const gift1InCart = gift1Qty > 0;
      const gift2InCart = gift2Qty > 0;

      // Detect manual removal between checks
      if (prevGift1InCart === true && !gift1InCart) {
        if (scriptRemovedGift1) {
          scriptRemovedGift1 = false;
        } else {
          console.log("[GIFT LOGIC] Gift1 removed manually; suppressing auto-add.");
          markGiftManuallyRemoved(1);
        }
      }

      if (prevGift2InCart === true && !gift2InCart) {
        if (scriptRemovedGift2) {
          scriptRemovedGift2 = false;
        } else {
          console.log("[GIFT LOGIC] Gift2 removed manually; suppressing auto-add.");
          markGiftManuallyRemoved(2);
        }
      }

      // We will batch our cart updates into a single object
      let updates = {};
      let needsUpdate = false;

      // Manage Gift 1 (Mask)
      if (cartTotal >= thresholdGift1) {
        // If it's missing OR if a glitch caused qty to be > 1, force it to exactly 1
        if ((!gift1InCart && !isGiftManuallyRemoved(1)) || gift1Qty > 1) {
          console.log("[GIFT LOGIC] Threshold met, setting first gift (mask) qty to 1.");
          updates[variantIdGift1] = 1;
          needsUpdate = true;
          clearGiftManuallyRemoved(1);
        }
      } else if (gift1InCart) {
        console.log("[GIFT LOGIC] Cart below threshold; removing first gift.");
        updates[variantIdGift1] = 0; // 0 removes it from the cart
        needsUpdate = true;
        scriptRemovedGift1 = true;
        clearGiftManuallyRemoved(1);
      }

      // Manage Gift 2 (Pillow)
      if (cartTotal >= thresholdGift2) {
        // Force qty to exactly 1
        if ((!gift2InCart && !isGiftManuallyRemoved(2)) || gift2Qty > 1) {
          console.log("[GIFT LOGIC] Threshold met, setting second gift (pillow) qty to 1.");
          updates[variantIdGift2] = 1;
          needsUpdate = true;
          clearGiftManuallyRemoved(2);
        }
      } else if (gift2InCart) {
        console.log("[GIFT LOGIC] Cart below threshold; removing second gift.");
        updates[variantIdGift2] = 0;
        needsUpdate = true;
        scriptRemovedGift2 = true;
        clearGiftManuallyRemoved(2);
      }

      // Save state for next comparison
      prevGift1InCart = gift1InCart;
      prevGift2InCart = gift2InCart;

      // If we need to add/remove/fix gifts, do it in ONE single API call
      if (needsUpdate) {
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: updates }),
        })
          .then((response) => response.json())
          .then((updatedCart) => {
            console.log("[GIFT LOGIC] Cart gifts updated successfully.");
            updateCartDrawer(); // Refresh UI only once!
            return updatedCart; // Pass the fresh cart data to the next step
          });
      }

      // If no updates were needed, just pass the existing data forward
      return data;
    })
    .then((cartData) => {
      // --- YOUR DISCOUNT DISPLAY LOGIC ---
      let totalDiscount = 0; 
      const cartItems = document.querySelectorAll(".cart-item"); 

      cartItems.forEach((item) => {
        const oldPriceElement = item.querySelector(".cart-item__old-price");
        if (oldPriceElement) {
          const priceText = oldPriceElement.textContent.trim().replace(/[^0-9.-]+/g, ""); 
          const priceValue = parseFloat(priceText); 
          if (!isNaN(priceValue)) {
            totalDiscount += priceValue;
          }
        }
      });

      function formatDiscount(value) {
        return (value / 100).toFixed(2).replace(".", ","); 
      }

      const discountElement = document.querySelector(".cart-discount");
      const kortingElement = document.querySelector(".totals_dispatch_Korting"); 
      
      if (discountElement && kortingElement) {
        if (totalDiscount > 0) {
          discountElement.textContent = formatDiscount(totalDiscount); 
          discountElement.style.display = "block"; 
          kortingElement.style.display = "block"; 
        } else {
          discountElement.style.display = "none"; 
          kortingElement.style.display = "none"; 
        }
      }
      console.log("[GIFT LOGIC] Total discount calculated:", totalDiscount);
    })
    .catch((error) => {
      console.error("Error fetching cart data:", error);
    })
    .finally(() => {
      isCheckingCart = false;
      console.log("[GIFT LOGIC] Cart check completed");
    });
}


  // Function to check if a product is already in the cart
  function isProductInCart(variantId) {
    return fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        return data.items.some((item) => item.variant_id === variantId);
      })
      .catch((error) => {
        console.error("Error checking cart:", error);
        return false;
      });
  }

  // Function to add a product to the cart
  function addProductToCart(variantId) {
    console.log("[GIFT LOGIC] addProductToCart called for variant:", variantId);
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("[GIFT LOGIC] Product added to cart:", data);
        updateCartDrawer(); // Refresh the cart drawer
      })
      .catch((error) => {
        console.error("[GIFT LOGIC] Error adding product to cart:", error);
      });
  }

  function removeProductFromCart(variantId) {
    console.log("[GIFT LOGIC] removeProductFromCart called for variant:", variantId);
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        // Find the cart item by variant ID
        const item = data.items.find((item) => item.variant_id === variantId);

        if (item) {
          // Prepare the request to remove the product by setting quantity to 0
          fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: item.key, // Use item.key from the cart.js response
              quantity: 0, // Set the quantity to 0 to remove the item
            }),
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error("Failed to remove product from cart.");
              }
              return response.json();
            })
            .then((updatedCart) => {
              console.log("[GIFT LOGIC] Product removed from cart:", updatedCart);
              updateCartDrawer(); // Refresh the cart drawer
            })
            .catch((error) => {
              console.error("[GIFT LOGIC] Error removing product from cart:", error);
            });
        } else {
          console.warn("[GIFT LOGIC] Product not found in cart for removal.");
        }
      })
      .catch((error) => {
        console.error("[GIFT LOGIC] Error fetching cart data for removal:", error);
      });
  }

  function detachAddToCartListeners() {
    const addToCartButtons = document.querySelectorAll(".upsell_addtocart_btn");
    addToCartButtons.forEach(function (button) {
      const newButton = button.cloneNode(true);
      button.replaceWith(newButton);
    });
  }

  function detachDropdownListeners() {
    const dropdowns = document.querySelectorAll(".variant-dropdown");
    dropdowns.forEach(function (dropdown) {
      const newDropdown = dropdown.cloneNode(true);
      dropdown.replaceWith(newDropdown);
    });
  }

  const cartDrawer = document.querySelector(".drawer__inner");
  console.log("cartDrawer", cartDrawer);
  if (cartDrawer) {
    const observer = new MutationObserver(() => {
      // Only schedule a debounced check; this avoids rapid, nested calls
      scheduleCheckCartAndManageProduct();
    });
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  // Initial check when the page loads
  checkCartAndManageProduct();
});
